import { MenuBar } from '../components/MenuBar'
import { Content } from '../components/Content'
import { Footer } from '../components/Footer'
import { HeaderBanner } from '../components/HeaderBanner'
import { ContactForm } from '../components/ContactForm'
import MetaTags from '../components/MetaTags'
import { Cookies } from '../components/Cookies'

import '../i18n/i18n'
import { useTranslation } from 'react-i18next'

import { TextBlock } from '../components/TextBlock'
import headerImage from '../public/assets/pages/contact-us/biker_seaside_1x33.jpg'
import { Header } from '../lib/strapi/responseTypes'
import { GetStaticProps } from 'next'
import { getHeaderQuery } from '../lib/strapi/queries'
import { IS_PRODUCTION } from '../config'
import { useRouter } from 'next/router'

type BasicPageData = { headerData: Header }

export default function ContactUsPage({headerData}: BasicPageData) {
  const { t: translate } = useTranslation()
  const { asPath } = useRouter();
  return (
    <>
      <MetaTags
        pageTitle={`${translate('contactUs')} - Protect Our Winters UK`}
      />
      <Cookies />
      <MenuBar currentPage={asPath} menuItems={headerData.data.attributes.menuItems} />
      <HeaderBanner imgSrc={headerImage} headingTranslationKey="contactUs" />
      <Content>
        <TextBlock>
          <p>
            Have a question? Want to get more involved in POW UK? We'd love to
            hear from you! Fill out the form below and a member of the team will
            get back to you asap.
          </p>
        </TextBlock>
        <ContactForm />
      </Content>

      <Footer />
    </>
  )
}

export const getStaticProps: GetStaticProps<BasicPageData> =
  async () => {

    const headerData = await getHeaderQuery({
      showPreview: !IS_PRODUCTION,
    })

    return {
      props: { headerData: headerData.header },
    }
  }
